import React from 'react';
import { useSelector } from 'react-redux';
import * as PT from 'prop-types';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import { getMSDataByEntity } from 'rdx/hardware';
import InputField from 'components/FieldTypes/InputField';

/**
 * Input field for selecting a microservice version.
 *
 * When MS versions are not available (f.ex. installer not installed), then defaults to a text field
 * Otherwise renders a dropdown of all versions, as well as any custom options passed in as children
 *
 * @param value Current value of the input field (either)
 * @param onChange onChange handler for the input field (either)
 * @param entity The name of the microservice to fetch version options for
 * @param children Custom options to prepend to the dropdown when versions are loaded
 * @param InputProps Custom props to add to the {@link InputField} component
 * @param defaultLabel Default label shown on the dropdown button if value is missing/empty
 */
function MsVersionInput({
  value,
  onChange,
  entity,
  children,
  InputProps,
  defaultLabel,
}) {
  const { builds } = useSelector(getMSDataByEntity(entity));

  if (!builds?.length) {
    return (
      <InputField
        {...InputProps}
        onChange={(e) => onChange(e.target.value)}
        value={value ?? ''}
      />
    );
  }

  return (
    <DropdownButton
      title={value || defaultLabel}
      className="w-100"
      value={value}
      onSelect={onChange}
    >
      {children}
      {builds.map((v) => (
        <Dropdown.Item key={v} eventKey={v} active={value === v}>
          {v}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
}
MsVersionInput.propTypes = {
  entity: PT.string,
  value: PT.string,
  onChange: PT.func,
  children: PT.any,
  InputProps: PT.object,
  defaultLabel: PT.string,
};

export default MsVersionInput;
